/**
 * Centralized channel player state management
 * Replaces global variables with a proper state object
 */

let playerState = {
  gAVplayObj: null,
  displayFullScreen: false,
  playerCoords: null,
  channelIndex: [],
  isPlayerBusy: false,
  playRequestId: 0,
  webosMediaId: null,
  url: null,
  httpLoopEnabled: false,
  httpLoopUrl: null,
  httpPlayTimeMs: 0,
  httpLastPlayAt: 0,
  streamReady: false,
};

/**
 * Update player state
 */
export const updatePlayerState = (updates) => {
  playerState = { ...playerState, ...updates };
};

/**
 * Get current player state
 */
export const getPlayerState = () => ({ ...playerState });

/**
 * Get specific player state property
 */
export const getPlayerStateProperty = (key) => playerState[key];

/**
 * Reset player to initial state
 */
export const resetPlayerState = () => {
  playerState = {
    gAVplayObj: null,
    displayFullScreen: false,
    playerCoords: null,
    channelIndex: [],
    isPlayerBusy: false,
    playRequestId: 0,
    webosMediaId: null,
    url: null,
    httpLoopEnabled: false,
    httpLoopUrl: null,
    httpPlayTimeMs: 0,
    httpLastPlayAt: 0,
    streamReady: false,
  };
};

/**
 * Increment play request ID for concurrent request tracking
 */
export const getNextPlayRequestId = () => {
  const newId = playerState.playRequestId + 1;
  playerState.playRequestId = newId;
  return newId;
};

/**
 * Add number to channel index buffer
 */
export const addChannelIndexNumber = (number) => {
  playerState.channelIndex.push(number);
};

/**
 * Clear channel index buffer
 */
export const clearChannelIndex = () => {
  playerState.channelIndex = [];
};

/**
 * Get current channel index buffer
 */
export const getChannelIndex = () => [...playerState.channelIndex];
